import { render, staticRenderFns } from "./FileInputs.vue?vue&type=template&id=e5bb550c&"
import script from "./FileInputs.vue?vue&type=script&lang=js&"
export * from "./FileInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VChip,VFileInput})
